/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa Basket Core
 *
 */
Intesa.BasketCore = function() {

	/**
	 * Local variables
	 *
	 */
	var basket_core = this;
	var loan = Intesa.LoanCalculator.getInstance();
	var basket_cookie = Intesa.BasketCookie.getInstance();
	var salaryActiveClass = ".itemActive";

	/**
	 * Class attributes
	 * 
	 */
	this.activeSalaryCode = "";
	this.boot = true;

	/**
	 * Init component
	 *
	 */
	this.init = function() {

		// check calculator
		if( !$( "section.cart .loansItem__list" ).length ) return;
		
		// change salary callback
		basket_core.changeSalaryCallback();

		// update active salary code
		if( $( ".-js-loansItem__link.itemActive" ).length ) {

			basket_core.activeSalaryCode = $( ".-js-loansItem__link.itemActive" ).data( "salaryCode" );

		}
			
		// change salary action
		$( document ).on( "click", ".-js-loansItem__link", function() {

			var target = $( this );

			// choose between with or without salary disclaimer
			basket_core.updateCartLoanDisclaimer();

			setTimeout( function() {

				if( target.data( "salaryCode" ) == basket_core.activeSalaryCode && !basket_core.boot ) {

					// remove salary callback
					basket_core.removeSalaryCallback();

				} else {

					// change salary callback
					basket_core.changeSalaryCallback( target );

				}

				basket_core.boot = false;

			}, 100);

		} );

		// remove salary action
		$( document ).on( "click", ".cart__summary__item--salary .cart__summary__item__remove", function( event ) {

			// remove salary callback
			basket_core.removeSalaryCallback();

		} );

	};

	/**
	 * Update Cart Loan Disclaimer
	 *
	 */
	this.updateCartLoanDisclaimer = function() {

		// without salary option doesn't have data-id attribute
		var isWithSalary = $( '.loansItem__link.itemActive' ).attr( 'data-id' ) ? true : false;

		if ( isWithSalary ) {

			// show with salary disclaimer
			$( '[data-disclaimer="with-salary"]' ).removeClass( 'hide' );
			$( '[data-disclaimer="without-salary"],[data-salary-box-info]' ).addClass( 'hide' );

		} else {

			// show without salary disclaimer
			$( '[data-disclaimer="with-salary"]' ).addClass( 'hide' );
			$( '[data-disclaimer="without-salary"],[data-salary-box-info]' ).removeClass( 'hide' );

		}

	};

	/**
	 * Change salary callback
	 * 
	 */
	this.changeSalaryCallback = function( target ) {

		// update salary active code
		if( target ) basket_core.activeSalaryCode = target.data( "salaryCode" );

		// init output elements
		loan.initOutputElements();

		// get inputs
		loan.getInputs( salaryActiveClass );

		// calculate
		loan.calculateLoan();

		// show results
		loan.fillOutputElements();

		// update basket price
		$( "*[data-mainproduct]" ).attr( "data-mainproduct", loan.monthlyInstallmentValuePromo );
		$( "*[data-mainproductstandard]" ).attr( "data-mainproductstandard", loan.monthlyInstallmentValueStandard );

		// update sum
		basket_core.eventDispatch( 'recalculatePercentage' );
		basket_core.eventDispatch( 'calculateSum' );

		// update basket cookie
		basket_core.updateBasketCookie( "promo" );

	};

	/**
	 * Event Dispatch
	 *
	 */
	this.eventDispatch = function( eventName ) {

		var event;

		if( typeof(Event) === 'function' ) {

			event = new Event( eventName );

		}else{

			event = document.createEvent( 'Event' );
			event.initEvent( eventName, true, true );

		}

		document.dispatchEvent(event);

	};

	/**
	 * Remove salary callback
	 *
	 */
	this.removeSalaryCallback = function() {

		// switch promo => standard
		loan.interestRatePromo.text( loan.interestRateResultStandard );
		loan.loanAmountPromo.text( loan.loanAmountResultStandard );
		loan.monthlyInstallmentPromo.text( loan.monthlyInstallmentResultStandard );

		// update sum
		$( "*[data-mainproduct]" ).attr( "data-mainproduct", loan.monthlyInstallmentValueStandard );

		// update salary list active
		$( ".-js-loansItem__link.-js-no-click" ).addClass( "itemActive" );

		// update sum
		basket_core.eventDispatch( 'recalculatePercentage' );
		basket_core.eventDispatch( 'calculateSum' );

		// update basket cookie
		basket_core.updateBasketCookie( "standard" );

	};

	/**
	 * Update personal loan configuration in cookie
	 * 
	 * @param {*} type 
	 */
    this.updateBasketCookie = function( type ) {

		var cookie = basket_cookie.getCookie( "product" );
		var cookieJSON = JSON.parse( cookie );
		var loanConfiguration = cookieJSON.personalLoanConfiguration;

		// update json object
		loanConfiguration.DURATION = loan.tenorCalculatedPromo.toString();

		if( type == "promo" ) {

			loanConfiguration.DISCOUNTCODE = loan.salaryInterestRateCode.toString();
			loanConfiguration.INSTALLMENT = loan.monthlyInstallmentValuePromo.toString();
			loanConfiguration.INTERESTRATE = loan.salaryInterestRateValue.toString();
			loanConfiguration.LOANAMOUNT = loan.loanAmountCalculatedPromo.toString();
			loanConfiguration.APR = loan.salaryAPRValue.toString();

		} else {

			if( loan.standardInterestRateCode != undefined ) loanConfiguration.DISCOUNTCODE = loan.standardInterestRateCode.toString();
			else loanConfiguration.DISCOUNTCODE = "";
			loanConfiguration.INSTALLMENT = loan.monthlyInstallmentValueStandard.toString();
			loanConfiguration.INTERESTRATE = loan.standardInterestRateValue.toString();
			loanConfiguration.LOANAMOUNT = loan.loanAmountCalculatedStandard.toString();
			loanConfiguration.APR = loan.standardAPRValue.toString();

		}

		cookie = JSON.stringify( cookieJSON );

		basket_cookie.setCookie( "product", cookie, 30 );

	};

};

/**
 * Get class instance
 *
 */
Intesa.BasketCore.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.basket_core ) {
		
		window.intesa.basket_core = new Intesa.BasketCore();
		
	}
	
	return window.intesa.basket_core;

};

/**
 * On DOM ready
 * 
 */
// $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {
    
    // init basket core
	var basket_core = Intesa.BasketCore.getInstance();
	basket_core.init();
	
} ); */
